import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class InventoryManagementService {
    private readonly getInventoryManagementURL = `/admin/inventory/transactions`;
    // ---------------------------------------------------------------

    getInventoryManagement(params: { size: number; page: number; type: string; startDate: string; endDate: string }) {
        return fetchWithRetry(API.get(this.getInventoryManagementURL, { params }));
    }
}

export default new InventoryManagementService();
